import { createContext } from 'react';

const UpsertUserContext = createContext({});

export default UpsertUserContext;
